import React from 'react';
import { useTranslation } from 'react-i18next';

import { images } from '../../constants';
import './Chef.css';

const Chef = () => {
  const { t } = useTranslation();
  return (
    <div className="section--sand section__padding app__chef">
      <div className="app__container">
        <div className="section__title">
          <h1 className="headtext__cormorant">{t('comfort')}</h1>
          <div className="section__title-accent" />
        </div>
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="" loading="lazy" />
          <p className="p__opensans1"><i>{t('human')}</i></p>
          <img src={images.quota} alt="" loading="lazy" />
        </div>
      </div>
    </div>
  );
};

export default Chef;
